import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CookieService } from 'ngx-cookie-service';
import { StoreService } from '../../_services/store.service';
import { KioskService } from '../../_services/kiosk.service';
import { ConfirmationService } from 'primeng/api';

@Component({
    selector: 'app-store-kiosks',
    templateUrl: './kiosks.component.html',
    styleUrls: ['./kiosks.component.css'],
})
export class StoreKiosksComponent implements OnInit {
    tabitems: any = [];

    storeId: any;
    selectedStore: any;
    selectedKiosk: any;
    cookieStore: any;

    role: any;
    routeRole: any;

    existingKiosks: any[] = [];
    kiosksModal = false;
    kiosksForm: FormGroup;

    constructor(
        public fb: FormBuilder,
        public activatedRoute: ActivatedRoute,
        public loader: LoadingBarService,
        public notificationService: NotificationService,
        public globals: Globals,
        public cookieService: CookieService,
        public router: Router,
        public _storeService: StoreService,
        public _kioskService: KioskService,
        public confirmationService: ConfirmationService
    ) {
        const hasCurrentStore = cookieService.check('currentStore');
        if (hasCurrentStore) {
            this.cookieStore = JSON.parse(cookieService.get('currentStore'));
            this.storeId = this.cookieStore.id;
        } else {
            this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
        }

        this.role = globals.user.role;
        this.routeRole = globals.user.routeRole;

        this.tabitems = [
            { path: '/' + this.routeRole + '/store/details', title: 'Details' },
            { path: '/' + this.routeRole + '/store/location', title: 'Location' },
            { path: '/' + this.routeRole + '/store/opening-times', title: 'Ordering Times' },
            { path: '/' + this.routeRole + '/store/media', title: 'Media' },
            { path: '/' + this.routeRole + '/store/payment-setup', title: 'Payment Setup' },
            { path: '/' + this.routeRole + '/store/pos-setup', title: 'POS Setup' },
            { path: '/' + this.routeRole + '/store/services', title: 'Services' },
        ];

        this.kiosksForm = fb.group({
            name: '',
            description: '',
        });
    }

    ngOnInit() {
        this.getStore(this.storeId);
    }

    public toggleKiosksModal() {
        this.kiosksModal = !this.kiosksModal;
    }

    // Get Store by id
    public getStore(id) {
        this._storeService.getStoreById(id).subscribe(
            (data: any) => {
                // console.log('Selected Store -> ', data);
                this.selectedStore = data;
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 0
                ) {
                    this.tabitems.push({
                        path: '/' + this.routeRole + '/store/delivery-times',
                        title: 'Delivery Times',
                    });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.deliveryOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Delivery Times').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Delivery Times'),
                        1
                    );
                }
                if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 0
                ) {
                    this.tabitems.push({ path: '/' + this.routeRole + '/store/kiosks', title: 'Kiosks' });
                } else if (
                    data.storeConfig !== null &&
                    data.storeConfig.kioskOrders === false &&
                    this.tabitems.filter((item) => item.title === 'Kiosks').length === 1
                ) {
                    this.tabitems.splice(
                        this.tabitems.findIndex((item) => item.title === 'Kiosks'),
                        1
                    );
                }
                this.getCurrentKiosks(data.storeConfig.id);
            },
            (err) => {
                console.log('Getting store by ID error, navigate to select store');
                this.router.navigate(['/' + this.globals.user.routeRole + '/select-store']);
            }
        );
    }

    // Get Existing Store Schedules
    public getCurrentKiosks(storeConfigId) {
        this._kioskService.getKiosksByStoreConfig(storeConfigId).subscribe((data: any) => {
            // console.log('Existing kiosks -> ', data);
            this.existingKiosks = data;
        });
    }

    public onKiosksFormSubmit() {
        const values = this.kiosksForm.value;
        // console.log('Form Values - ', values);
        const obj = {
            name: values.name,
            enabled: true,
            description: values.description,
            storeConfigId: this.selectedStore.storeConfig.id,
        };
        this._kioskService.createKiosk(obj).subscribe(() => {
            this.kiosksForm.reset();
            this.toggleKiosksModal();
            this.getCurrentKiosks(this.selectedStore.storeConfig.id);
            this.notificationService.notify(
                'success',
                'Kiosk Added',
                'New Kiosk successfully added',
                'top',
                'right'
            );
        });
    }

    public deleteKiosk(kioskId) {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to delete this kiosk?',
            accept: () => {
                // Actual logic to perform a confirmation
                this._kioskService.deleteKiosk(kioskId).subscribe((data: any) => {
                    // console.log(data);
                    this.notificationService.notify(
                        'success',
                        'Kiosk Deleted',
                        'Kiosk has successfully been deleted',
                        'top',
                        'right'
                    );
                    this.getCurrentKiosks(this.selectedStore.storeConfig.id);
                });
            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/indi-store/kiosks/kiosks.component.ts